import { createSlice } from '@reduxjs/toolkit';

type ErrorMessage = {
  operation: string;
  message: string[];
};

export type ErrorState = {
  error: ErrorMessage | null;
};

export const initialErrorState: ErrorState = {
  error: null,
};

export const errorSlice = createSlice({
  name: 'error',
  initialState: initialErrorState,
  reducers: {
    setGeneralError: (state, { payload }) => {
      state.error = payload;
      return state;
    },
    clearError: (state, { payload }) => {
      state.error = null;
      return state;
    },
  },
});

export const { setGeneralError, clearError } = errorSlice.actions;

export const selectError = (state: { error: ErrorState }) => state.error;
